export const letterD = {
  nouns: [
    {"lady": ["Dame", "Damen", "die", "die", "f"]},
    {"date": ["Datum", "Daten", "das", "die", "n"]},
    {"disco": ["Disco", "Discos", "die", "die", "f"]},
    {"doctor": ["Doktor", "Doktoren", "der", "die", "m"]},
    {"double room": ["Doppelzimmer", "Doppelzimmer", "das", "die", "n"]},
    {"village": ["Dorf", "Dörfer", "das", "die", "n"]},
    {"printer": ["Drucker", "Drucker", "der", "die", "m"]},
    {"announcement": ["Durchsage", "Durchsagen", "die", "die", "f"]},
    {"thirst": ["Durst", "Durst", "der", "die", "m"]},
    {"shower": ["Dusche", "Duschen", "die", "die", "f"]},
    {"Tuesday": ["Dienstag", "Dienstage", "der", "die", "m"]},
    {"German": ["Deutsch", "Deutsch", "das", "die", "n"]},
    {"Germany": ["Deutschland", "Deutschländer", "das", "die", "n"]},
    {"December": ["Dezember", "Dezembers", "der", "die", "m"]},
    {"theater": ["Theater", "Theater", "das", "die", "n"]},
    {"dictionary": ["Wörterbuch", "Wörterbücher", "das", "die", "n"]},
    {"door": ["Tür", "Türen", "die", "die", "f"]},
    {"thousand": ["Tausend", "Tausende", "das", "die", "n"]},
    {"teacher": ["Lehrer", "Lehrer", "der", "die", "m"]},
    {"tea": ["Tee", "Tees", "der", "die", "m"]},
    {"table": ["Tisch", "Tische", "der", "die", "m"]},
    {"toe": ["Zeh", "Zehen", "der", "die", "f"]},
    {"taxi": ["Taxi", "Taxis", "das", "die", "n"]},
    {"toilet": ["Toilette", "Toiletten", "die", "die", "f"]},
    {"town": ["Stadt", "Städte", "die", "die", "f"]},
    {"train": ["Zug", "Züge", "der", "die", "m"]},
    {"tram": ["Tram", "Trams", "die", "die", "f"]},
    {"ticket": ["Fahrkarte", "Fahrkarten", "die", "die", "f"]},
    {"text": ["Text", "Texte", "der", "die", "m"]},
    {"telephone": ["Telefon", "Telefone", "das", "die", "n"]},
    {"television": ["Fernsehen", "Fernseher", "das", "die", "n"]},
    {"television": ["Fernseher", "Fernseher", "der", "die", "m"]},
    {"time": ["Zeit", "Zeiten", "die", "die", "f"]},
    {"daughter": ["Tochter", "Töchter", "die", "die", "f"]},
    {"dog": ["Hund", "Hunde", "der", "die", "m"]},
    {"dance": ["Tanz", "Tänze", "der", "die", "m"]},
    {"dream": ["Traum", "Träume", "der", "die", "m"]},
    {"distance": ["Entfernung", "Entfernungen", "die", "die", "f"]},
    {"direction": ["Richtung", "Richtungen", "die", "die", "f"]},
    {"danger": ["Gefahr", "Gefahren", "die", "die", "f"]},
    {"difference": ["Unterschied", "Unterschiede", "der", "die", "m"]},
    {"decision": ["Entscheidung", "Entscheidungen", "die", "die", "f"]},
    {"discussion": ["Diskussion", "Diskussionen", "die", "die", "f"]},
    {"development": ["Entwicklung", "Entwicklungen", "die", "die", "f"]},
    {"difficulty": ["Schwierigkeit", "Schwierigkeiten", "die", "die", "f"]},
    {"document": ["Dokument", "Dokumente", "das", "die", "n"]},
    {"dinner": ["Abendessen", "Abendessen", "das", "die", "n"]},
    {"dress": ["Kleid", "Kleider", "das", "die", "n"]},
    {"roof": ["Dach", "Dächer", "das", "die", "n"]},
    {"thanks": ["Dank", "Dank", "der", "der", "m"]},
    {"ceiling/blanket": ["Decke", "Decken", "die", "die", "f"]},
    {"service": ["Dienst", "Dienste", "der", "die", "m"]},
    {"thing": ["Ding", "Dinge", "das", "die", "n"]},
    {"cathedral": ["Dom", "Dome", "der", "die", "m"]},
    {"can/tin": ["Dose", "Dosen", "die", "die", "f"]},
    {"pressure/print": ["Druck", "Drucke", "der", "die", "m"]},
    {"passage": ["Durchgang", "Durchgänge", "der", "die", "m"]},
    {"mess/confusion": ["Durcheinander", "Durcheinander", "das", "die", "n"]}

  ],
  verbs: [
    {"to thank": ["danken", "danke", "dankst", "dankt", "dankt", "dankt", "danken", "dankt", "danken", "danken"]},
    {"to last": ["dauern", "dauere", "dauerst", "dauert", "dauert", "dauert", "dauern", "dauert", "dauern", "dauern"]},
    {"to print": ["drucken", "drucke", "druckst", "druckt", "druckt", "druckt", "drucken", "druckt", "drucken", "drucken"]},
    {"to press": ["drücken", "drücke", "drückst", "drückt", "drückt", "drückt", "drücken", "drückt", "drücken", "drücken"]},
    {"to be allowed to": ["dürfen", "darf", "darfst", "darf", "darf", "darf", "dürfen", "dürft", "dürfen", "dürfen"]},
    {"to shower": ["duschen", "dusche", "duschst", "duscht", "duscht", "duscht", "duschen", "duscht", "duschen", "duschen"]},
    {"to do": ["machen", "mache", "machst", "macht", "macht", "macht", "machen", "macht", "machen", "machen"]},
    {"to give": ["geben", "gebe", "gibst", "gibt", "gibt", "gibt", "geben", "gebt", "geben", "geben"]},
    {"to think": ["denken", "denke", "denkst", "denkt", "denkt", "denkt", "denken", "denkt", "denken", "denken"]},
    {"to drink": ["trinken", "trinke", "trinkst", "trinkt", "trinkt", "trinkt", "trinken", "trinkt", "trinken", "trinken"]},
    {"to try": ["versuchen", "versuche", "versuchst", "versucht", "versucht", "versucht", "versuchen", "versucht", "versuchen", "versuchen"]},
    {"to dance": ["tanzen", "tanze", "tanzst", "tanzt", "tanzt", "tanzt", "tanzen", "tanzt", "tanzen", "tanzen"]},
    {"to decide": ["entscheiden", "entscheide", "entscheidest", "entscheidet", "entscheidet", "entscheidet", "entscheiden", "entscheidet", "entscheiden", "entscheiden"]},
    {"to discuss": ["diskutieren", "diskutiere", "diskutierst", "diskutiert", "diskutiert", "diskutiert", "diskutieren", "diskutiert", "diskutieren", "diskutieren"]},
    {"to develop": ["entwickeln", "entwickle", "entwickelst", "entwickelt", "entwickelt", "entwickelt", "entwickeln", "entwickelt", "entwickeln", "entwickeln"]},
    {"to dream": ["träumen", "träume", "träumst", "träumt", "träumt", "träumt", "träumen", "träumt", "träumen", "träumen"]},
    {"to drive": ["fahren", "fahre", "fährst", "fährt", "fährt", "fährt", "fahren", "fahrt", "fahren", "fahren"]},
    {"to discover": ["entdecken", "entdecke", "entdeckst", "entdeckt", "entdeckt", "entdeckt", "entdecken", "entdeckt", "entdecken", "entdecken"]},
    {"to describe": ["beschreiben", "beschreibe", "beschreibst", "beschreibt", "beschreibt", "beschreibt", "beschreiben", "beschreibt", "beschreiben", "beschreiben"]},
    {"to divide": ["teilen", "teile", "teilst", "teilt", "teilt", "teilt", "teilen", "teilt", "teilen", "teilen"]},
    {"to find": ["finden", "finde", "findest", "findet", "findet", "findet", "finden", "findet", "finden", "finden"]},
    {"to direct": ["leiten", "leite", "leitest", "leitet", "leitet", "leitet", "leiten", "leitet", "leiten", "leiten"]},
    {"to doubt": ["zweifeln", "zweifle", "zweifelst", "zweifelt", "zweifelt", "zweifelt", "zweifeln", "zweifelt", "zweifeln", "zweifeln"]},
    {"to dominate": ["dominieren", "dominiere", "dominierst", "dominiert", "dominiert", "dominiert", "dominieren", "dominiert", "dominieren", "dominieren"]},
    {"to draw": ["zeichnen", "zeichne", "zeichnest", "zeichnet", "zeichnet", "zeichnet", "zeichnen", "zeichnet", "zeichnen", "zeichnen"]},
    {"to dress": ["anziehen", "ziehe an", "ziehst an", "zieht an", "ziehen an", "zieht an", "ziehen an", "zieht an", "ziehen an", "ziehen an"]},
    {"to deliver": ["liefern", "liefere", "liefert", "liefert", "liefert", "liefert", "liefern", "liefert", "liefern", "liefern"]},
    {"to destroy": ["zerstören", "zerstöre", "zerstörst", "zerstört", "zerstört", "zerstört", "zerstören", "zerstört", "zerstören", "zerstören"]},
    {"to distribute": ["verteilen", "verteile", "verteilst", "verteilt", "verteilt", "verteilt", "verteilen", "verteilt", "verteilen", "verteilen"]},
    {"to disturb": ["stören", "störe", "störst", "stört", "stört", "stört", "stören", "stört", "stören", "stören"]},
    {"to donate": ["spenden", "spende", "spendest", "spendet", "spendet", "spendet", "spenden", "spendet", "spenden", "spenden"]},
    {"to drag": ["ziehen", "ziehe", "ziehst", "zieht", "zieht", "zieht", "ziehen", "zieht", "ziehen", "ziehen"]},
    {"to have to": ["müssen", "muss", "musst", "muss", "muss", "muss", "müssen", "müsst", "müssen", "müssen"]},
    {"to want": ["wollen", "will", "willst", "will", "will", "will", "wollen", "wollt", "wollen", "wollen"]},
    {"to be able to": ["können", "kann", "kannst", "kann", "kann", "kann", "können", "könnt", "können", "können"]},
    {"to should": ["sollen", "soll", "sollst", "soll", "soll", "soll", "sollen", "sollt", "sollen", "sollen"]},
    {"to must": ["müssen", "muss", "musst", "muss", "muss", "muss", "müssen", "müsst", "müssen", "müssen"]},
    {"to will": ["wollen", "will", "willst", "will", "will", "will", "wollen", "wollt", "wollen", "wollen"]},
    {"to can": ["können", "kann", "kannst", "kann", "kann", "kann", "können", "könnt", "können", "können"]},
    {"to become": ["werden", "werde", "wirst", "wird", "wird", "wird", "werden", "werdet", "werden", "werden"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Dame ist nett.',
        english: 'The lady is nice.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Dank ist groß.',
        english: 'The thanks is great.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Datum ist wichtig.',
        english: 'The date is important.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Disco ist laut.',
        english: 'The disco is loud.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Doktor kommt.',
        english: 'The doctor comes.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Doppelzimmer ist frei.',
        english: 'The double room is free.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Dorf ist klein.',
        english: 'The village is small.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Drucker ist neu.',
        english: 'The printer is new.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Durchsage ist klar.',
        english: 'The announcement is clear.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Durst ist groß.',
        english: 'The thirst is great.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Dusche ist warm.',
        english: 'The shower is warm.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Dienstag ist heute.',
        english: 'Tuesday is today.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Deutsch ist schwer.',
        english: 'The German language is difficult.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Deutschland ist groß.',
        english: 'Germany is big.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Tür ist offen.',
        english: 'The door is open.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Tisch ist schön.',
        english: 'The table is beautiful.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Zeit ist wichtig.',
        english: 'Time is important.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Tochter spielt.',
        english: 'The daughter plays.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Hund bellt.',
        english: 'The dog barks.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Tanz ist schön.',
        english: 'The dance is beautiful.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Traum war interessant.',
        english: 'The dream was interesting.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Dokument ist wichtig.',
        english: 'The document is important.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Getränk ist kalt.',
        english: 'The drink is cold.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Abendessen war gut.',
        english: 'The dinner was good.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Kleid ist rot.',
        english: 'The dress is red.',
        answer: 'Das',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich sehe ___ Dame.',
        english: 'I see the lady.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er hat ___ Dank.',
        english: 'He has the thanks.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie braucht ___ Datum.',
        english: 'She needs the date.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir besuchen ___ Disco.',
        english: 'We visit the disco.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du rufst ___ Doktor.',
        english: 'You call the doctor.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Ich buche ___ Doppelzimmer.',
        english: 'I book the double room.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Sie liebt ___ Dorf.',
        english: 'She loves the village.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Er kauft ___ Drucker.',
        english: 'He buys the printer.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Wir hören ___ Durchsage.',
        english: 'We hear the announcement.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du hast ___ Durst.',
        english: 'You have thirst.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Ich nehme ___ Dusche.',
        english: 'I take the shower.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Sie öffnet ___ Tür.',
        english: 'She opens the door.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er kauft ___ Tisch.',
        english: 'He buys the table.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Wir haben ___ Zeit.',
        english: 'We have time.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du siehst ___ Tochter.',
        english: 'You see the daughter.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er streichelt ___ Hund.',
        english: 'He pets the dog.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie liebt ___ Tanz.',
        english: 'She loves the dance.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Ich erinnere ___ Traum.',
        english: 'I remember the dream.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Wir lesen ___ Dokument.',
        english: 'We read the document.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Du trinkst ___ Getränk.',
        english: 'You drink the drink.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Sie isst ___ Abendessen.',
        english: 'She eats the dinner.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Er kauft ___ Kleid.',
        english: 'He buys the dress.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir brauchen ___ Drucker.',
        english: 'We need printer.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du hast ___ Dorf.',
        english: 'You have village.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Ich danke ___ Dank.',
        english: 'I thank the thanks.',
        answer: 'den',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich spreche mit ___ Dame.',
        english: 'I speak with the lady.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er gibt ___ Dank.',
        english: 'He gives thanks.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie arbeitet mit ___ Datum.',
        english: 'She works with the date.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir tanzen in ___ Disco.',
        english: 'We dance in the disco.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du gehst zu ___ Doktor.',
        english: 'You go to the doctor.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich schlafe in ___ Doppelzimmer.',
        english: 'I sleep in the double room.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie lebt in ___ Dorf.',
        english: 'She lives in the village.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Er arbeitet mit ___ Drucker.',
        english: 'He works with the printer.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir hören ___ Durchsage.',
        english: 'We listen to the announcement.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du hast wegen ___ Durst.',
        english: 'You have because of thirst.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich dusche mich mit ___ Dusche.',
        english: 'I shower with the shower.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Sie steht vor ___ Tür.',
        english: 'She stands in front of the door.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er sitzt an ___ Tisch.',
        english: 'He sits at the table.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: '___ Zeit fuer den Termin ist da.',
        english: 'It is time for the appointment.',
        answer: 'die',
        case: 'dative'
      },
      {
        german: 'Du hilfst ___ Tochter.',
        english: 'You help the daughter.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Er spielt mit ___ Hund.',
        english: 'He plays with the dog.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie tanzt ___ Tanz.',
        english: 'She dances the dance.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich träume von ___ Traum.',
        english: 'I dream about the dream.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir lesen in ___ Dokument.',
        english: 'We read in the document.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du trinkst aus ___ Getränk.',
        english: 'You drink from the drink.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie isst bei ___ Abendessen.',
        english: 'She eats at the dinner.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Er kauft für ___ Kleid.',
        english: 'He buys for the dress.',
        answer: 'das',
        case: 'dative'
      },
      {
        german: 'Wir danken ___ Dank.',
        english: 'We thank the thanks.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Du gehst zu ___ Dorf.',
        english: 'You go to the village.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich danke ___ Dame.',
        english: 'I thank the lady.',
        answer: 'der',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The lady is nice.',
        german: ['Die Dame ist nett.', 'Die Frau ist nett.'],
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The thanks is great.',
        german: 'Der Dank ist groß.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The date is important.',
        german: 'Das Datum ist wichtig.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The disco is loud.',
        german: 'Die Disco ist laut.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The doctor comes.',
        german: ['Der Doktor kommt.', 'Der Arzt kommt.'],
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The double room is free.',
        german: 'Das Doppelzimmer ist frei.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The village is small.',
        german: 'Das Dorf ist klein.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The printer is new.',
        german: 'Der Drucker ist neu.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The announcement is clear.',
        german: 'Die Durchsage ist klar.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The thirst is great.',
        german: 'Der Durst ist groß.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The shower is warm.',
        german: 'Die Dusche ist warm.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The door is open.',
        german: 'Die Tür ist offen.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The table is beautiful.',
        german: 'Der Tisch ist schön.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'Time is important.',
        german: 'Die Zeit ist wichtig.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The daughter plays.',
        german: 'Die Tochter spielt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The dog barks.',
        german: 'Der Hund bellt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The dream was interesting.',
        german: 'Der Traum war interessant.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'I thank you.',
        german: 'Ich danke Ihnen.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The lesson lasts.',
        german: 'Die Stunde dauert.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'He prints the document.',
        german: 'Er druckt das Dokument.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'You press the button.',
        german: 'Du drückst den Knopf.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'You are allowed to come.',
        german: 'Du darfst kommen.',
        type: 'translation',
        caseType: 'modal'
      },
      {
        english: 'I shower in the morning.',
        german: 'Ich dusche morgens.',
        type: 'translation',
        caseType: 'verb'
      },
      {
        english: 'She is taking a shower.',
        german: 'Sie duscht gerade.',
        type: 'translation',
        caseType: 'verb'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to thank" for "I"?',
        answer: 'danke',
        verb: 'danken',
        verbEnglish: 'to thank',
        subject: 'ich',
        conjugation: 'danke'
      },
      {
        question: 'How do you conjugate "to thank" for "you" (informal)?',
        answer: 'dankst',
        verb: 'danken',
        verbEnglish: 'to thank',
        subject: 'du',
        conjugation: 'dankst'
      },
      {
        question: 'How do you conjugate "to thank" for "he/she/it"?',
        answer: 'dankt',
        verb: 'danken',
        verbEnglish: 'to thank',
        subject: 'er/sie/es',
        conjugation: 'dankt'
      },
      {
        question: 'How do you conjugate "to thank" for "we"?',
        answer: 'danken',
        verb: 'danken',
        verbEnglish: 'to thank',
        subject: 'wir',
        conjugation: 'danken'
      },
      {
        question: 'How do you conjugate "to thank" for "you" (plural)?',
        answer: 'dankt',
        verb: 'danken',
        verbEnglish: 'to thank',
        subject: 'ihr',
        conjugation: 'dankt'
      },
      {
        question: 'How do you conjugate "to thank" for "they/formal you"?',
        answer: 'danken',
        verb: 'danken',
        verbEnglish: 'to thank',
        subject: 'sie/Sie',
        conjugation: 'danken'
      },
      {
        question: 'How do you conjugate "to last" for "I"?',
        answer: 'dauere',
        verb: 'dauern',
        verbEnglish: 'to last',
        subject: 'ich',
        conjugation: 'dauere'
      },
      {
        question: 'How do you conjugate "to last" for "you" (informal)?',
        answer: 'dauerst',
        verb: 'dauern',
        verbEnglish: 'to last',
        subject: 'du',
        conjugation: 'dauerst'
      },
      {
        question: 'How do you conjugate "to last" for "he/she/it"?',
        answer: 'dauert',
        verb: 'dauern',
        verbEnglish: 'to last',
        subject: 'er/sie/es',
        conjugation: 'dauert'
      },
      {
        question: 'How do you conjugate "to print" for "I"?',
        answer: 'drucke',
        verb: 'drucken',
        verbEnglish: 'to print',
        subject: 'ich',
        conjugation: 'drucke'
      },
      {
        question: 'How do you conjugate "to press" for "you" (informal)?',
        answer: 'drückst',
        verb: 'drücken',
        verbEnglish: 'to press',
        subject: 'du',
        conjugation: 'drückst'
      },
      {
        question: 'How do you conjugate "to shower" for "he"?',
        answer: 'duscht',
        verb: 'duschen',
        verbEnglish: 'to shower',
        subject: 'er',
        conjugation: 'duscht'
      },
      {
        question: 'How do you conjugate "to be allowed to" for "I"?',
        answer: 'darf',
        verb: 'dürfen',
        verbEnglish: 'to be allowed to',
        subject: 'ich',
        conjugation: 'darf'
      },
      {
        question: 'How do you conjugate "to be allowed to" for "you" (informal)?',
        answer: 'darfst',
        verb: 'dürfen',
        verbEnglish: 'to be allowed to',
        subject: 'du',
        conjugation: 'darfst'
      },
      {
        question: 'How do you conjugate "to be allowed to" for "we"?',
        answer: 'dürfen',
        verb: 'dürfen',
        verbEnglish: 'to be allowed to',
        subject: 'wir',
        conjugation: 'dürfen'
      },
      {
        question: 'How do you conjugate "to think" for "I"?',
        answer: 'denke',
        verb: 'denken',
        verbEnglish: 'to think',
        subject: 'ich',
        conjugation: 'denke'
      },
      {
        question: 'How do you conjugate "to think" for "she"?',
        answer: 'denkt',
        verb: 'denken',
        verbEnglish: 'to think',
        subject: 'sie',
        conjugation: 'denkt'
      },
      {
        question: 'How do you conjugate "to drink" for "I"?',
        answer: 'trinke',
        verb: 'trinken',
        verbEnglish: 'to drink',
        subject: 'ich',
        conjugation: 'trinke'
      },
      {
        question: 'How do you conjugate "to drink" for "you" (plural)?',
        answer: 'trinkt',
        verb: 'trinken',
        verbEnglish: 'to drink',
        subject: 'ihr',
        conjugation: 'trinkt'
      },
      {
        question: 'How do you conjugate "to try" for "we"?',
        answer: 'versuchen',
        verb: 'versuchen',
        verbEnglish: 'to try',
        subject: 'wir',
        conjugation: 'versuchen'
      }
    ]
  }
}
